import type { ReactNode } from 'react';
import type { FallbackProps } from 'react-error-boundary';
import { QueryErrorResetBoundary } from '@tanstack/react-query';

import type { ErrorBoundaryProps } from './ErrorBoundary';
import { ErrorBoundary } from './ErrorBoundary';

export type QueryErrorBoundaryProps = Omit<
  ErrorBoundaryProps,
  'severity' | 'onReset' | 'FallbackComponent' | 'fallback' | 'fallbackRender'
> & {
  severity?: ErrorBoundaryProps['severity'];
  fallbackRender: (props: FallbackProps) => ReactNode;
};

export function QueryErrorBoundary({
  severity = 'medium',
  fallbackRender,
  children,
  ...restProps
}: QueryErrorBoundaryProps) {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary severity={severity} fallbackRender={fallbackRender} onReset={() => reset()} {...restProps}>
          {children}
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
}
